             import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { NavLink as RouterLink, useNavigate } from 'react-router-dom';

import { Box, Divider, Stack, Typography } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import {fDateYear} from "../../utils/formatTime";
import SimBContainer from '../../components/container/SimBContainer';
import {
  SvgFacebookFill,
  SvgFacebookOutline,
  SvgInstagramFill,
  SvgInstagramOutline, 
  SvgLinkedinFill, 
  SvgLinkedinOutline,
  SvgTwitterFill,
  SvgTwitterOutline,
  SvgYoutubeFill, 
  SvgYoutubeOutline,
} from '../../components/SvgIcons';
import { LogoMode } from '../../components/logo';
import useResponsive from '../../hooks/useResponsive';
import { getStorage } from '../../utils/storage';
import { ACCESS_TOKEN } from '../../store/types';
import { useRouter } from '../../hooks/useRoutes';
import { MODES } from '../../store/constant';





/* ======================================================================== */


const FooterContainer = styled('footer')(({ theme }) => ({
  paddingTop: theme.spacing(6),
  paddingBottom: theme.spacing(3),
  position: 'relative',
  borderTop: `4px solid ${theme.colors.separate}`,
  zIndex: 1
}));

const IconsColumns = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'auto 1fr',
  alignItems: 'center',
  textAlign: 'center',
  paddingBottom: theme.spacing(3),

  [theme.breakpoints.down('lg')]: {
    gridTemplateColumns: 'none',
    gridTemplateRows: '1fr',
    justifyContent: 'center'
  },
}));


const LinksColumns = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'auto auto',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingTop: theme.spacing(3),
  borderTop: `1px solid ${theme.palette.color.secondaryDark}`,
  [theme.breakpoints.down('lg')]: {
    gridTemplateColumns: 'none',
    gridTemplateRows: '1fr',
    justifyContent: 'center',
    gap: '2px',
    textAlign: 'center',
  },
}));


const AppColumns = styled('div')(({ theme }) => ({
    display: 'flex',
    // display: 'grid',
    // gridTemplateColumns: 'repeat(auto-fill, minmax(0px, 200px))',
    alignItems: 'flex-start',
    padding: theme.spacing(3, 0),
    [theme.breakpoints.down('lg')]: {
        // gridTemplateRows: '1fr',
        justifyContent: 'center',
        gap: theme.spacing(2)
    },
  '& > div' : { flex: 1 }
}));

/* ======================================================================== */


export default function Footer({ copyright }) {
    const theme = useTheme();
    const { t } = useTranslation();
    const navigator = useNavigate();

    const isDesktop = useResponsive('up', 'lg');

    const accessToken = getStorage(ACCESS_TOKEN);

    const { onIcivetAuthorize } = useRouter();

    const icons = [MODES.Dark].includes(theme.palette.mode) ? [
      { icon: <SvgFacebookFill />, url: 'https://www.facebook.com/HonHai.Technology' },
      { icon: <SvgInstagramFill />, url: 'https://www.instagram.com/foxconn.tw' },
      { icon: <SvgTwitterFill />, url: 'https://twitter.com/HonHai_Foxconn' },
      { icon: <SvgLinkedinFill />, url: 'https://www.linkedin.com/company/鴻海精密工業股份有限公司' },
      { icon: <SvgYoutubeFill />, url: 'https://www.youtube.com/channel/UC6WVXDQDbzMaM98itJH-vOw' }
    ] : [
      { icon: <SvgFacebookOutline />, url: 'https://www.facebook.com/HonHai.Technology' },
      { icon: <SvgInstagramOutline />, url: 'https://www.instagram.com/foxconn.tw' },
      { icon: <SvgTwitterOutline />, url: 'https://twitter.com/HonHai_Foxconn' },
      { icon: <SvgLinkedinOutline />, url: 'https://www.linkedin.com/company/鴻海精密工業股份有限公司' },
      { icon: <SvgYoutubeOutline />, url: 'https://www.youtube.com/channel/UC6WVXDQDbzMaM98itJH-vOw' }
    ];

    const links = [
      // { txt: '更新日誌',     name: t('更新日誌'), link:  () => accessToken ? navigator('/honhai/logs') : onIcivetAuthorize() },
      { txt: '法律與商標',   name: t('法律與商標'), link: () => navigator('/honhai/law-trademark') },
      { txt: '隱私權與政策', name: t('隱私權與政策'), link: () => navigator('/honhai/privacy-policy') },
      { txt: 'Cookie 政策', name: t('Cookie 政策'), link: () => navigator('/honhai/cookie-policy') },
      { txt: '友善連結',  name: t('友善連結'), link: () => accessToken ? navigator('/honhai/site-links') : onIcivetAuthorize() },
      { txt: '網站地圖',  name: t('網站地圖'), link: () => accessToken ? navigator('/honhai/site-map') : onIcivetAuthorize() }
    ]

    return(
        <FooterContainer>
          <SimBContainer>

            <IconsColumns>
              <Box display={'flex'} gap={1.5} justifyContent={'center'} alignItems={'center'}>
                <LogoMode mode={theme.palette.mode} width={160} height={32} link={'https://www.honhai.com/'} target={'_blank'} />
              </Box>
              {
                isDesktop ? null : (
                  <Box my={3}>
                    <Typography variant={'body2'} textAlign={'center'} mb={0.25}>236 新北市土城區土城工業區自由街2號</Typography>
                    <Typography variant={'body2'} textAlign={'center'}>+886-2-2268-3466</Typography>
                  </Box>
                )
              }
              <Stack
                direction={'row'}
                spacing={1.5}
                sx={{
                  justifyContent: 'flex-end',
                  [theme.breakpoints.down('lg')]: {
                    justifyContent: 'center'
                  },
                }}
              >
                {
                  _.map(icons, (item, index) => {
                    return (
                      <Box
                        key={index}
                        onClick={() => window.open(item?.url)}
                        lineHeight={0}
                        sx={{
                          cursor: 'pointer',
                          'i': {
                            display: 'inline-block',
                            transition: 'all ease 0.3s'
                          },
                          '&:hover': {
                            'i': {
                              transform: 'translateY(-5px)',
                            }
                          }
                        }}
                      >
                        <Box component={'i'}>
                          { item?.icon }
                        </Box>
                      </Box>
                    )
                  })
                }
              </Stack>
            </IconsColumns>

            {/* <AppColumns>
            {
              _.map(footerLinks || [], (item, index) => {
                const { label, catalogType, children, props } = item || {};
                const { logoSrc, path } = props || {};
                return (
                  <Box key={index}>
                    <Typography variant={'h4'} mb={1}>{label}</Typography>
                    {
                      ['link'].includes(catalogType) ? (
                        <Stack spacing={1}>
                          {
                            _.map(children || [], (cell, idx) => {
                              return (
                                <Typography
                                  key={idx}
                                  component={'span'}
                                  variant={'body1'}
                                  onClick={() => window.open(cell?.props?.redirectUrl)}
                                  sx={{ transition: 'all 300ms ease', cursor: 'pointer', '&:hover': { color: 'error.main' } }}
                                >
                                  {cell.label}
                                </Typography>
                              )
                            })
                          }
                        </Stack>
                      ) : (
                        <Box component={RouterLink} to={path} width={92} height={92} display={'block'}>
                          <Box width={1} component={`img`} src={logoSrc} />
                        </Box>
                      )
                    }
                  </Box>
                )
              })
            }
          </AppColumns> */}


            <LinksColumns>
              <Stack spacing={0.5}>
                {/* <Typography variant={'body2'}>
                  客服信箱：hsiuli@foxconn.com &nbsp;
                  郵務客服信箱：joe.kc.weng@foxconn.com
                </Typography> */}
                <Typography variant={'body2'} color={theme.colors.text.primary}>
                  Copyright © { fDateYear(new Date()) }&nbsp;
                  {/* 鴻海精密工業股份有限公司著作權所有 */}
                  { t('cgam.copyright.ai') }
                </Typography>
              </Stack>
              {/* <Stack spacing={0.5}>
                <Typography variant={'body2'}>今日訪客數：{ today_visitor_number }</Typography>
                <Typography variant={'body2'}>總閱覽人數：{ total_readers_number }</Typography>
              </Stack> */}
              
              {copyright}
            </LinksColumns>
          </SimBContainer>
        </FooterContainer>
    )
}
